import { Container } from '@/components/ui/container';
import { Section, SectionHeading } from '@/components/ui/section';

const approaches = [
  {
    title: 'MPC wallets',
    body: 'Multi-party computation distributes signing across key shares. Evaluate the provider’s policy engine, signing environment, and recovery model alongside the cryptography.',
  },
  {
    title: 'Smart contract multisigs',
    body: 'Multisigs authorize transactions with a threshold of owner signatures. Platforms such as Safe can add modules and guards, so evaluate the complete wallet configuration.',
  },
  {
    title: 'Wallet-as-a-Service',
    body: 'WaaS provides wallet infrastructure through APIs and SDKs. Compare customer onboarding, signing controls, supported networks, and the permissions your application needs.',
  },
];

export function Comparison() {
  return (
    <Section id="comparison" className="border-y border-hairline bg-surface">
      <Container className="max-w-[1200px]">
        <SectionHeading
          eyebrow="Compare wallet infrastructure"
          title="Choose how your wallet enforces control."
          description="Signing technology, transaction policies, and wallet APIs solve different problems. Compare how they work together for your operations."
          align="left"
        />
        <div className="mt-10 grid gap-6 md:grid-cols-3">
          {approaches.map((approach) => (
            <div
              key={approach.title}
              className="rounded-2xl border border-hairline bg-white p-7"
            >
              <h3 className="text-xl font-semibold text-ink-900">
                {approach.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-ink-500">
                {approach.body}
              </p>
            </div>
          ))}
        </div>
        <div className="mt-8 rounded-2xl border border-ember-100 bg-white p-7 sm:p-9">
          <h3 className="text-xl font-semibold text-ink-900">
            Den: multi-layer policy enforcement
          </h3>
          <p className="mt-3 max-w-3xl text-base leading-relaxed text-ink-500">
            Den combines treasury operations and Wallet-as-a-Service with
            transaction policies checked by the signing client, the Guardian,
            and onchain smart contracts. Review the standard transaction flow
            and the separately configured recovery mechanisms as part of your
            security evaluation.
          </p>
        </div>
      </Container>
    </Section>
  );
}
